'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _totalaudit = require('./totalaudit.html');

var _totalaudit2 = _interopRequireDefault(_totalaudit);

var _totalaudit3 = require('./totalaudit.controller');

var _totalaudit4 = _interopRequireDefault(_totalaudit3);

require('./totalaudit.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var totalauditComponent = {
  restrict: 'E',
  bindings: {},
  template: _totalaudit2.default,
  controller: _totalaudit4.default,
  controllerAs: 'vm'
};

exports.default = totalauditComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/totalaudit/totalaudit.component.js